module.exports = __webpack_public_path__ + "img/visa-logo.7cd3f93e.svg";